import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import CssBaseline from '@mui/material/CssBaseline'
import { store } from './store/store.js'
import App from './App.jsx'
import { CustomThemeProvider } from './context/ThemeContext.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <CustomThemeProvider>
        <CssBaseline />
        <App />
      </CustomThemeProvider>
    </Provider>
  </React.StrictMode>,
)